<template>
  <div class="gp-table-wrap">
    <div class="gp-table-desktop">
      <EasyDataTable
        v-bind="$attrs"
        :headers="headers"
        :items="filteredItems"
        :model-value="modelValue"
        :body-row-class-name="rowClass"
        table-class-name="garantepay-table"
        rows-per-page-message="Linhas por página"
        empty-message="Nenhum registro encontrado"
        @update:model-value="$emit('update:modelValue', $event)"
      >
        <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
          <slot :name="slotName" v-bind="slotProps || {}" />
        </template>
      </EasyDataTable>
    </div>

    <div class="gp-table-mobile">
      <div v-if="!mobileItems.length" class="gp-mobile-empty">Nenhum registro encontrado</div>
      <article v-for="(item, index) in mobileItems" :key="mobileItemKey(item, index)" class="gp-mobile-row" :class="rowClass(item, index)">
        <div v-for="header in headers" :key="header.value" class="gp-mobile-field"
          :class="{ 'gp-mobile-actions': header.value === 'actions' }">
          <span class="gp-mobile-label">{{ header.text }}</span>
          <div class="gp-mobile-value">
            <slot :name="`item-${header.value}`" v-bind="item">{{ item[header.value] ?? '—' }}</slot>
          </div>
        </div>
      </article>
      <div v-if="mobileTotalPages > 1" class="gp-mobile-pagination">
        <button type="button" :disabled="mobilePage === 1" @click="mobilePage--">
          <v-icon size="17">mdi-chevron-left</v-icon>
        </button>
        <span>{{ mobilePage }} de {{ mobileTotalPages }}</span>
        <button type="button" :disabled="mobilePage === mobileTotalPages" @click="mobilePage++">
          <v-icon size="17">mdi-chevron-right</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EasyDataTable from 'vue3-easy-data-table'

export default {
  name: 'GarantePayDataTable',
  components: { EasyDataTable },
  inheritAttrs: false,
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    searchValue: { type: String, default: '' },
    modelValue: { type: Array, default: () => [] },
    mobileRowsPerPage: { type: Number, default: 10 },
    rowClass: { type: Function, default: () => '' }
  },
  emits: ['update:modelValue'],
  data: () => ({ mobilePage: 1 }),
  computed: {
    filteredItems () {
      const termo = this.normalize(this.searchValue)
      if (!termo) return this.items
      return this.items.filter(item => this.objectValues(item).some(value => this.normalize(value).includes(termo)))
    },
    mobileTotalPages () {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.mobileRowsPerPage))
    },
    mobileItems () {
      const inicio = (this.mobilePage - 1) * this.mobileRowsPerPage
      return this.filteredItems.slice(inicio, inicio + this.mobileRowsPerPage)
    }
  },
  watch: {
    items () { this.mobilePage = 1 },
    searchValue () { this.mobilePage = 1 }
  },
  methods: {
    normalize (value) {
      return String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    },
    objectValues (value) {
      if (value === null || value === undefined) return []
      if (typeof value !== 'object') return [value]
      return Object.values(value).flatMap(item => this.objectValues(item))
    },
    mobileItemKey (item, index) {
      return item.id ?? item.cliId ?? item.cusId ?? item.tpeId ?? `${this.mobilePage}-${index}`
    }
  }
}
</script>

<style scoped>
.gp-table-mobile { display: none; }
@media (max-width: 767.98px) {
  .gp-table-desktop { display: none; }
  .gp-table-mobile { display: block; padding: 10px; background: #f8f5ef; }
  .gp-mobile-row { margin-bottom: 10px; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 11px; background: #fffdf9; box-shadow: 0 5px 14px rgba(16,42,90,.05); }
  .gp-mobile-field { display: grid; grid-template-columns: minmax(92px, 35%) 1fr; gap: 10px; align-items: start; padding: 7px 10px; border-bottom: 1px solid #eee8de; }
  .gp-mobile-field:last-child { border-bottom: 0; }
  .gp-mobile-label { color: #69758a; font-size: 9px; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }
  .gp-mobile-value { min-width: 0; color: #17223b; font-size: 11px; line-height: 1.35; overflow-wrap: anywhere; }
  .gp-mobile-actions { align-items: center; }
  .gp-mobile-empty { padding: 28px 15px; color: #68748a; font-size: 12px; text-align: center; }
  .gp-mobile-pagination { display: flex; align-items: center; justify-content: center; gap: 12px; padding: 5px 0 2px; color: #68748a; font-size: 11px; }
  .gp-mobile-pagination button { width: 30px; height: 30px; display: grid; place-items: center; border: 1px solid #d8d2c8; border-radius: 8px; background: #fff; color: #102a5a; }
  .gp-mobile-pagination button:disabled { opacity: .4; }
}
</style>
